export default "__VITE_ASSET__1a884a72__"